import React from 'react';
import useGenerateInitialVersionStore from '../../../../stores/useGenerateInitialVersionStore';
import GenerateInitialVersionModal from './GenerateInitialVersionModal';
import {useParentReportContent} from './useParentReportContent';

/**
 * GlobalGenerateInitialVersionModal - A globally accessible modal wrapper
 * that connects to the Zustand store.
 *
 * This component should be rendered once at a high level in the app
 * (e.g., in ReportPageLayout).
 *
 * The modal can be opened from anywhere using the store:
 *
 * ```js
 * import useGenerateInitialVersionStore from '../../../../stores/useGenerateInitialVersionStore';
 *
 * const openModal = useGenerateInitialVersionStore(s => s.openModal);
 * openModal({ instructions: 'some instructions', selectedPolicy: 'strict' });
 * ```
 */
const GlobalGenerateInitialVersionModal = () => {
    const isOpen = useGenerateInitialVersionStore(s => s.isOpen);
    const closeModal = useGenerateInitialVersionStore(s => s.closeModal);
    const instructions = useGenerateInitialVersionStore(s => s.instructions);
    const selectedPolicy = useGenerateInitialVersionStore(s => s.selectedPolicy);

    // Use the parent report content hook - this fetches data from useReportStore
    const {
        parentContent,
        parentReportId,
        parentVersion,
        parentMeta,
        loading,
        error
    } = useParentReportContent();

    // Always render the modal, let GenerateInitialVersionModal handle visibility
    return (
        <GenerateInitialVersionModal
            isOpen={isOpen}
            onClose={closeModal}
            parentContent={parentContent}
            parentReportId={parentReportId}
            parentVersion={parentVersion}
            parentMeta={parentMeta}
            loading={loading}
            error={error}
            instructions={instructions}
            selectedPolicy={selectedPolicy}
        />
    );
};

export default GlobalGenerateInitialVersionModal;
